<h1 mat-dialog-title>Overturn {{punishment.player.username}}'s {{punishment.type.toLowerCase()}}?</h1>
<div mat-dialog-content>
  Are you sure you want to overturn {{punishment.player.username}}'s {{punishment.type.toLowerCase()}}?<br><br>
  They were {{punishment.type === 'MUTE' ? 'muted' : 'banned'}} by {{punishment.moderator.username}} - <b>make sure you check with them!</b>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="no()">Nevermind.</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true">Yes!</button>
</div>
